// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-page-js" + "-" + "b0ded0411f27da5ae977" + ".js";
};